import { Tooltip as MuiTooltip } from '@material-ui/core';

export const Tooltip = MuiTooltip;
